import { Disclaimer } from "../components/Disclaimer";
import { NTNSearch } from "../components/NTNSearch";
import { NameSearch } from "../components/NameSearch";
import React, { useState, useContext } from "react";
import { FBRDataContext } from "../context/FBRDataContext";

export function HomePage({ nav, t }) {
  const { recordCount } = useContext(FBRDataContext);
  const [searchTab, setSearchTab] = useState("ntn");
  return (
    <div>
      <div className="hero">
        <div className="hero-eyebrow">{t("hero_eyebrow")}</div>
        <h1 className="hero-title">{t("hero_title")}<br /><em>{t("hero_title_em")}</em></h1>
        <p className="hero-sub">{t("hero_sub")}</p>
        {recordCount > 0 && (
          <div className="hero-stat">
            <span className="hero-stat-count">{recordCount.toLocaleString()}</span>
            <span className="hero-stat-label">{t("stat_businesses_label")}</span>
          </div>
        )}
        <div className="hero-btns">
          <button className="btn btn-ghost"   onClick={() => nav("upload")}>📷 {t("scan_receipt")}</button>
        </div>

        <div style={{ maxWidth: 600, margin: '40px auto', textAlign: 'left' }}>
          <div className="form-card" style={{ boxShadow: '0 10px 25px var(--accent-glow)', padding: 0, overflow: 'hidden' }}>
            <div className="search-tab-row">
              <button className={`search-tab ${searchTab === "ntn" ? "search-tab-active" : ""}`} onClick={() => setSearchTab("ntn")}>
                🔢 {t("search_by_ntn")}
              </button>
              <button className={`search-tab ${searchTab === "name" ? "search-tab-active" : ""}`} onClick={() => setSearchTab("name")}>
                🏪 {t("search_by_name")}
              </button>
            </div>
            <div style={{ padding: '28px 32px' }}>
              {searchTab === "ntn"  && <NTNSearch t={t} />}
              {searchTab === "name" && <NameSearch t={t} />}
            </div>
          </div>
        </div>
        <div className="hero-badges">
          <span className="hero-badge">✅ {t("all_business_types")}</span>
          <span className="hero-badge">🗄️ {t("fbr_atl_database")}</span>
          <span className="hero-badge">🔍 {t("name_ntn_search")}</span>
          <span className="hero-badge">📷 {t("receipt_scanner")}</span>
          <span className="hero-badge">🆓 {t("always_free")}</span>
        </div>
      </div>

      <div className="container">
        <Disclaimer t={t} />
        <div className="how-grid">
          {[
            { icon:"🔍", title:t("how_title_1"),  text:t("how_text_1").replace("{count}", recordCount.toLocaleString()) },
            { icon:"🔢", title:t("how_title_2"),  text:t("how_text_2") },
            { icon:"📷", title:t("how_title_3"),  text:t("how_text_3") },
            { icon:"🏛️", title:t("how_title_4"),  text:t("how_text_4") },
          ].map(s => (
            <div key={s.title} className="how-card">
              <div className="how-icon">{s.icon}</div>
              <div className="how-title">{s.title}</div>
              <div className="how-text">{s.text}</div>
            </div>
          ))}
        </div>

        <div className="authority-grid">
          <div className="section-title" style={{ gridColumn:"1/-1" }}>{t("official_authorities")}</div>
          {[
            { name:"FBR",  full:t("auth_fbr_full"),  url:"https://fbr.gov.pk",            region:t("region_federal") },
            { name:"SRB",  full:t("auth_srb_full"),  url:"https://srb.gos.pk",            region:t("region_sindh") },
            { name:"PRA",  full:t("auth_pra_full"),  url:"https://pra.punjab.gov.pk",     region:t("region_punjab") },
            { name:"KPRA", full:t("auth_kpra_full"), url:"https://kpra.gov.pk",           region:t("region_kpk") },
            { name:"BRA",  full:t("auth_bra_full"),  url:"https://bra.gob.pk",            region:t("region_balochistan") },
          ].map(a => (
            <a key={a.name} className="authority-card" href={a.url} target="_blank" rel="noopener noreferrer">
              <div className="authority-name">{a.name}</div>
              <div className="authority-full">{a.full}</div>
              <div className="authority-region">{a.region}</div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
